import { MouseEvent, useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import '../css/Footer.css'
import { AFWebLinkType, handlePostMessage, RNPostMessage } from '../js/postMessage'
import { getParsedSessionStorageItem } from '../js/script'
import usePreviousPath from '../hooks/usePreviousPath'
import { getKakaoToken, getUserData } from '../api/kakao'
import { getRandomNickname, postCreateUser, postKakaoSocialLogin } from '../api/login'
import { detect } from 'detect-browser'
import { useAppContext } from './provider/AppProvider'

// 이미지 경로
export const imgURL = '/images'

export default function Footer() {
  const previousPath = usePreviousPath()
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const [count, setCount] = useState<number>(0)
  const [os, setOs] = useState<string>('')

  useEffect(() => {
    const browerOs = detect()
    setOs(browerOs?.os as string)
  }, [])

  useEffect(() => {
    if (count > 10) {
      alert(window.location.href)
      alert(previousPath)
    }
  }, [count])

  return (
    <div className='footer_wrap'>
      <footer>
        {/* 회사정보 */}
        <div className='company_info'>
          <p className='name'>(주)어바웃피싱</p>
          <ul className='info'>
            <li>
              <span>사업자 등록번호 : 631-81-02422</span>
              <span>대표 : 송동현</span>
            </li>
            <li>
              <span>통신판매업 신고번호 : 2021-서울종로-1872</span>
            </li>
            <li>
              <span>주소 : 서울특별시 종로구 효자로 15, 3층(통의동, 다모여빌딩)</span>
            </li>
            {isMobile ? (
              <li>
                <span>고객센터 : contact@aboutfishing.kr</span>
                <span>02-723-0365</span>
              </li>
            ) : (
              <li>
                <span>이메일 : contact@aboutfishing.kr</span>
                <span>02-723-0365</span>
              </li>
            )}
          </ul>

          {/* 유틸메뉴 */}
          <ul className='util_menu'>
            <li>
              <div
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/terms`,
                    })
                  } else {
                    navigate(`/terms`)
                  }
                }}
              >
                이용약관
              </div>
            </li>
            <li>
              <div
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/privacypolicy`,
                    })
                  } else {
                    navigate(`/privacypolicy`)
                  }
                }}
              >
                개인정보 취급방침
              </div>
            </li>
            <li>
              <div
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/refundpolicy`,
                    })
                  } else {
                    navigate(`/refundpolicy`)
                  }
                }}
              >
                환불정책
              </div>
            </li>
            <li>
              <Link to='mailto:business@aboutfishing.kr'>입점/제휴문의</Link>
            </li>
          </ul>
          <div className='escrow'>
            <a
              href='https://mark.inicis.com/mark/escrow_popup_v3.php?mid=GDSAF06010'
              target='__blank'
              onClick={(e: MouseEvent<HTMLAnchorElement>): void => {
                e.preventDefault()
                const app: any = getParsedSessionStorageItem('app')
                if (app) {
                  // moveToLinkNaver(
                  //   'https://mark.inicis.com/mark/escrow_popup_v3.php?mid=GDSAF06010'
                  // );
                  handlePostMessage({
                    actionType: 'moveToLinkNaver',
                    params: { url: 'https://mark.inicis.com/mark/escrow_popup_v3.php?mid=GDSAF06010' },
                  })
                } else {
                  window.open('https://mark.inicis.com/mark/escrow_popup_v3.php?mid=GDSAF06010')
                }
              }}
            >
              에스크로 이니페이
              {/* <img src={`${imgURL}/icon_escrow.png`} alt='에스크로' /> */}
            </a>
          </div>
          <button
            style={{ width: '30px', height: '30px', opacity: 0 }}
            onClick={() => {
              setCount((prev) => prev + 1)
            }}
          ></button>
          <ul className='sns'>
            <li>
              <a
                href='https://www.instagram.com/aboutfishing_official'
                target='_blank'
                title='어바웃피싱 인스타그램으로 바로가기(새 창에서 열기)'
                className='instagram'
                rel='noreferrer'
              >
                <img src={`${imgURL}/img_instagram.png`} alt='인스타그램 로고' width='18' height='18' loading='lazy' />
              </a>
            </li>
            <li>
              <a
                href='https://www.facebook.com/aboutfishing.page/?locale=ko_KR'
                target='_blank'
                title='어바웃피싱 페이스북으로 바로가기(새 창에서 열기)'
                className='facebook'
                rel='noreferrer'
              >
                <img src={`${imgURL}/img_facebook.png`} alt='페이스북 로고' width='8' height='16' loading='lazy' />
              </a>
            </li>
            <li>
              <a
                href='https://blog.naver.com/aboutfishing0601'
                target='_blank'
                title='어바웃피싱 공식 블로그로 바로가기(새 창에서 열기)'
                className='blog'
                rel='noreferrer'
              >
                <img
                  src={`${imgURL}/img_naver_blog.png`}
                  alt='네이버 블로그 로고'
                  width='22'
                  height='10'
                  loading='lazy'
                />
              </a>
            </li>
            <li>
              <a
                href='https://www.youtube.com/channel/UC6O1ziBnzhkPRat477Nt9fA'
                target='_blank'
                title='어바웃피싱 유튜브로 바로가기(새 창에서 열기)'
                className='youtube'
                rel='noreferrer'
              >
                <img src={`${imgURL}/img_youtube.png`} alt='유튜브 로고' width='18' height='12' loading='lazy' />
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  )
}
